import { jmAreaselect } from '@/components/tool';
import { isEmpty } from '@/utils/utils';

export default {
  components: {
    jmAreaselect
  },
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    }
  },
  model: {
    prop: 'formData',
    event: 'change'
  },
  data() {
    return {
      bornplace: [],
      nowplace: [],
    };
  },
  computed: {
    hasGaoKao: {
      set(val) {
        this.formData.gaokao = val;
      },
      get() {
        return this.formData.gaokao > 0;
      }
    },
    hasGeneralExam: {
      set(val) {
        this.formData.general_exam = val;
      },
      get() {
        return this.formData.general_exam > 0;
      }
    },
    hasArtExam: {
      set(val) {
        this.formData.is_art_exam = val;
      },
      get() {
        return this.formData.is_art_exam > 0;
      }
    }
  },
  methods: {
    /**
     * 填充用户出生地信息
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    initBornPlace() {
      this.bornplace = [
        this.formData.born_place_area,
        this.formData.born_place_city
      ];
    },
    setBornPlaceData(v) {
      this.formData.born_place_area = v[0];
      this.formData.born_place_city = v[1];
    },
    initNowPlace() {
      this.nowplace = [
        this.formData.now_place_area,
        this.formData.now_place_city
      ];
    },
    setNowPlaceData(v) {
      this.formData.now_place_area = v[0];
      this.formData.now_place_city = v[1];
    },
  },
  watch: {
    formData: {
      handler(v) {
        this.$emit('change', v);
        if (!isEmpty(v)) {
          this.initBornPlace();
          this.initNowPlace();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initBornPlace();
      this.initNowPlace();
    });
  },
};
